import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "flex flex-col h-full" };
const _hoisted_2 = ["onClick", "checked"];
const _hoisted_3 = {
    key: 1,
    class: "flex flex-row items-center justify-items-start"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-calendar" }, null, -1);
const _hoisted_5 = { key: 2 };
export function render(_ctx, _cache) {
    const _component_search_bar = _resolveComponent("search-bar");
    const _component_Button = _resolveComponent("Button");
    const _component_user_navigation_icon = _resolveComponent("user-navigation-icon");
    const _component_empty_table_state = _resolveComponent("empty-table-state");
    const _component_Table = _resolveComponent("Table");
    const _component_renew_vault_access_modal = _resolveComponent("renew-vault-access-modal");
    const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_search_bar, {
            lazy: "",
            class: "my-2 w-full max-w-md",
            searchValue: _ctx.userSearch,
            "onUpdate:searchValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userSearch) = $event))
        }, null, 8, ["searchValue"]),
        _withDirectives((_openBlock(), _createBlock(_component_Table, {
            headers: _ctx.headers,
            "default-sort": _ctx.sortedField,
            "onUpdate:default-sort": _cache[1] || (_cache[1] = ($event) => ((_ctx.sortedField) = $event)),
            "backend-pagination-sorting": "",
            onSortChanged: _ctx.sortUsers,
            data: _ctx.users,
            emptyMessage: _ctx.$t('filter.usersNotFound'),
            "is-loading": _ctx.isLoading
        }, {
            "data-checkbox": _withCtx(({ row }) => [
                (row.id !== _ctx.currentUser.id)
                    ? (_openBlock(), _createElementBlock("input", {
                        class: "ml-3 w-4 h-4",
                        type: "checkbox",
                        onClick: ($event) => (_ctx.addUserToList(row)),
                        checked: _ctx.usersToRemove[row.id],
                        key: _ctx.usersToRemove[row.id]
                    }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true)
            ]),
            "data-lastAccessed": _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.lastAccessed ? _ctx.formatDate(row.lastAccessed) : _ctx.$t('tables.headers.neverLoggedIn')), 1)
            ]),
            "data-expiryDate": _withCtx(({ row }) => [
                (row.expiryDate && new Date(row.expiryDate) < new Date())
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "bg-primary text-white mx-0 px-0",
                        colored: "",
                        onClick: ($event) => (_ctx.showRenewAccessForUser(row))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('vault.renewAccess')), 1)
                        ]),
                        _: 2
                    }, 1032, ["onClick"]))
                    : (row.expiryDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            _createTextVNode(_toDisplayString(row.expiryDate ? _ctx.formatDate(row.expiryDate, false) : '') + " ", 1),
                            _createVNode(_component_Button, {
                                class: "ml-1",
                                onClick: ($event) => (_ctx.showRenewAccessForUser(row))
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_4
                                ]),
                                _: 2
                            }, 1032, ["onClick"])
                        ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, " - "))
            ]),
            tableEmptyState: _withCtx(() => [
                _createVNode(_component_empty_table_state, null, {
                    icon: _withCtx(() => [
                        _createVNode(_component_user_navigation_icon, { class: "h-8 w-8 mx-auto text-gray-400" })
                    ]),
                    header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('filter.usersNotFound')), 1)
                    ]),
                    content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('filter.userInviteMessage')), 1)
                    ]),
                    _: 1
                })
            ]),
            loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('tables.loadingState.userLoading')) + "... ", 1)
            ]),
            _: 1
        }, 8, ["headers", "default-sort", "onSortChanged", "data", "emptyMessage", "is-loading"])), [
            [_directive_infinite_scroll, {
                    trigger: _ctx.getMoreUsers,
                    options: { limit: 15 },
                }]
        ]),
        (_ctx.showRenewAccess && !!_ctx.renewUser)
            ? (_openBlock(), _createBlock(_component_renew_vault_access_modal, {
                key: 0,
                user: _ctx.renewUser,
                vault: _ctx.workspaceDetails,
                show: _ctx.showRenewAccess,
                "onUpdate:show": _cache[2] || (_cache[2] = ($event) => ((_ctx.showRenewAccess) = $event)),
                onRenewedUser: _ctx.updateRenewedUser,
                onClose: _cache[3] || (_cache[3] = ($event) => (_ctx.renewUser = undefined))
            }, null, 8, ["user", "vault", "show", "onRenewedUser"]))
            : _createCommentVNode("", true)
    ]));
}
